// extracted by mini-css-extract-plugin
export var root = "author-list-module--root--2ZJIK";
export var headline = "author-list-module--headline--2JSiW typography-module--base--34V38";
export var list = "author-list-module--list--2c6ah";
export var listItem = "author-list-module--listItem--2guyK";
export var avatar = "author-list-module--avatar--mkVhj";